import React from "react";
import Launch from "../../Launch";
import { OnboardingFormProps } from "../Types";

const LaunchStep: React.FC<OnboardingFormProps> = () => (
  <div style={{ width: "100%", maxWidth: "800px", textAlign: "left" }}>
    <h1>🚀 Launch</h1>
    <p style={{ marginTop: 0, marginBottom: "24px", color: "#6b7280", lineHeight: "1.2" }}>
      We will prepare a Template, First Edition, and Launch Email for your newsletter. You'll receive an email when each one is ready for review.
    </p>
    <Launch />
  </div>
);

export default LaunchStep;
